export class CycleVieBpm {
    id: string = '';
    real_id: string = '';
    libele: string = '';
    modele: string = '';
    statut_depart?: string = '';
    statut_depart_prod?:string ='';
    services =[]
  }